const CollateralBuildDesign = () => import('@/views/collateral-build/collateral-build-design-view');
const CollateralBuildCreate = () => import('@/views/collateral-build/collateral-build-create-view');
const CollateralBuildIndex = () => import('@/views/collateral-build/collateral-build-index-view');
const CollateralBuildAccountUpgrade = () => import('@/views/collateral-build/collateral-build-account-upgrade-view');

export default [
{
    path: '/CollateralBuilds',
    name: 'CollateralBuildIndex',
    component: CollateralBuildIndex,
    meta: {
        subtype: 'library',
        isUiShown: true,
        pageClass: 'collateral-build-index-page',
        pageTitle: 'Collateral Builder'
    }
},
{
    path: '/Account/Upgrade/CollateralBuilds',
    name: 'CollateralBuildAccountUpgrade',
    component: CollateralBuildAccountUpgrade,
    meta: {
        subtype: 'library',
        isUiShown: true,
        pageClass: 'account-upgrade-collateral-build-page',
        pageTitle: 'Account Upgrade Collateral Build '
    }
},
{
    path: '/Clients/:clientId/Account/Upgrade/CollateralBuilds',
    name: 'ClientCollateralBuildAccountUpgrade',
    component: CollateralBuildAccountUpgrade,
    meta: {
        subtype: 'library',
        isUiShown: true,
        pageClass: 'account-upgrade-collateral-build-page',
        pageTitle: 'Account Upgrade Collateral Build '
    }
},
{
    path: '/Clients/:clientId/CollateralBuilds',
    name: 'ClientCollateralBuildIndex',
    component: CollateralBuildIndex,
    meta: {
        subtype: 'library',
        isUiShown: true,
        pageClass: 'collateral-build-index-page',
        pageTitle: 'Collateral Builder'
    }
},
{
    path: '/Agencies/:agencyId/CollateralBuilds',
    name: 'AgencyCollateralBuildIndex',
    component: CollateralBuildIndex,
    meta: {
        type: 'agency',
        isUiShown: true,
        pageClass: 'collateral-build-index-page',
        pageTitle: 'Collateral Builder'
    }
},
{
    path: '/CollateralBuilds/:collateralBuildId/Design',
    name: 'CollateralBuildDesign',
    component: CollateralBuildDesign,
    meta: {
        subtype: 'library',
        isUiShown: false,
        pageClass: 'collateral-build-design-page'
    }
},
{
    path: '/CollateralBuilds/Create',
    name: 'CollateralBuildCreate',
    component: CollateralBuildCreate,
    meta: {
        subtype: 'library',
        isUiShown: true,
        pageClass: 'collateral-build-create-page',
        pageTitle: 'Create Collateral Builder'
    }
},
{
    path: '/Agencies/:agencyId/CollateralBuilds/Create',
    name: 'AgencyCollateralBuildCreate',
    component: CollateralBuildCreate,
    meta: {
        type: 'agency',
        isUiShown: true,
        pageClass: 'collateral-build-create-page',
        pageTitle: 'Create Collateral Builder'
    }
},
{
    path: '/Clients/:clientId/CollateralBuilds/Create',
    name: 'ClientCollateralBuildCreate',
    component: CollateralBuildCreate,
    meta: {
        type: 'client',
        subtype: 'library',
        isUiShown: true,
        pageClass: 'collateral-build-create-page',
        pageTitle: 'Create Collateral Builder'
    }
}]